import axios from "axios";

export const nodeTreeJson = (destination_url) => {
  return axios
    .post(destination_url)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const sendUpdatedJson = (payload, destination_url) => {
  return axios
    .post(destination_url, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }



export const selectFilter = (payload, destination_url) => {
  return axios
    .post(destination_url, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
